import React, { useEffect, useState } from "react";
import { faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/material";
import EditModal from "../../../components/common/Profile/EditModal";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import EditModalAccount from "../../../components/common/Profile/EditAccount";
import AddEditAddressModal from "../../../components/common/Profile/AddEditAddress";
import { useDispatch, useSelector } from "react-redux";
import { deleteAddress, getCustomerStaffList, getProfileView, updateProfile } from "../../../redux/reducers/authSlice";
import { getPostalSectors } from "../../../redux/reducers/postalSectorsSlice";
import { clearDatahandling } from "../../../utils/clearDataHandling";
import CancelConfirmModel from "../../../components/cancelConfirmModel/CancelConfirmModel";
import { getDateFormat } from "../../../utils/commonFuncs";
import ChangePasswordModal from "../../../components/common/ChangePasswordModal";
import { Badge } from "react-bootstrap";
const MyProfile = () => {
  const dispatch = useDispatch()
  const { myprofile, prefferdStaffList, user } = useSelector((state) => state.auth)
  const [open, setOpen] = React.useState(false);
  const [showAccountModal, setShowAccountModal] = React.useState(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = React.useState(false);
  const [showAddressModal, setShowAddressModal] = React.useState(false);
  const [selectedData, setSelectedData] = React.useState(null);
  const [changePassword, setChangePassword] = React.useState(false);
  const { postalData
  } = useSelector((state) => state.poastalSectorsLists);




  useEffect(() => {
    dispatch(getProfileView())
  }, [])
  useEffect(() => {
  }, [myprofile])
  useEffect(() => {
    dispatch(getPostalSectors())


  }, [])
  React.useEffect(() => {
    dispatch(getCustomerStaffList())
  }, [])
  const editPrefferdStaffhandler = () => {

    setOpen(true)

  }

  useEffect(() => {
    clearDatahandling(dispatch)

  }, [])

  const updateNotificationFlag = (check) => {
    let values = {
      isNotify: check
    }
    dispatch(updateProfile({ values: values, dispatch: dispatch }))
  }
  const confirmDelete = () => {
    setShowDeleteConfirmationModal(false)
    dispatch(deleteAddress({ cusId: user?.customer?._id, locationId: selectedData?._id, dispatch }))

  }
  const cancelDelete = () => {
    setShowDeleteConfirmationModal(false)
    setSelectedData(null)
  }
  return (
    <>
      <div className="Dashboard-page-main">
        <div className="Dashboard-page-wrap">
          <div className="profile-main max-720">
            <div className="profile-heading upcoming-sec">
              <h2>Profile</h2>
            </div>
            <div className="acc-information">
              <div className="d-flex justify-content-between align-items-baseline">
                <div className="profile-acc-inf"> Account Information </div>
                <Button
                  className="edit-btn"
                  variant="outlined"
                  onClick={() => {

                    setShowAccountModal(true);
                  }}
                >
                  Edit
                </Button>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="acc-inf-d">
                    <p>First Name</p>
                    <h4>{myprofile?.fname}</h4>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="acc-inf-d">
                    <p>Last Name</p>
                    <h4>{myprofile?.lname}</h4>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="acc-inf-d">
                    <p>Email</p>
                    <h4>{myprofile?.email}</h4>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="acc-inf-d">
                    <p>Mobile Number</p>
                    <h4>+{myprofile?.countryCode} {myprofile?.phoneNumber}</h4>
                  </div>
                </div>
                {myprofile?.customer?.dob && <div className="col-md-6">
                  <div className="acc-inf-d">
                    <p>Date of birth</p>
                    <h4>{getDateFormat(new Date(myprofile?.customer?.dob))}</h4>
                  </div>
                </div>}
                <div className="col-md-6">
                  <div className="acc-inf-d">
                    <p>Property Type</p>
                    <h4>{myprofile?.customer?.property_type}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="acc-information">
              <div className="profile-acc-inf pointer" onClick={() => setChangePassword(true)}> Change Password? </div>
            </div>
            <div className="acc-information mb-4">
              <div className="d-flex justify-content-between align-items-baseline">
                <div className="d-flex justify-content-between w-100">
                  <div className="profile-acc-inf"> Address </div>
                  <Button
                    className="edit-btn"
                    variant="outlined"
                    onClick={() => {
                      setSelectedData(null)
                      setShowAddressModal(true);
                    }}
                  >
                    Add
                  </Button>
                </div>
                {/* <Button
                  className="edit-btn"
                  variant="outlined"
                  onClick={() => {
                    setSelectedData(null)
                    setShowAddressModal(true);
                  }}
                >
                  Add
                </Button> */}
              </div>
              {myprofile?.customer?.locations?.length > 0 && myprofile?.customer?.locations.map((val, idx) => (
                <>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="acc-inf-d">

                        <div className="d-flex justify-content-between align-items-center">
                          <p>{val?.title}</p>

                          <div className="d-flex align-items-center justify-content-end">
                            <Button className="edit-btn"
                              variant="outlined"
                              onClick={() => {
                                setSelectedData(val)
                                setShowAddressModal(true);
                              }}
                            >
                              Edit
                            </Button>
                            {myprofile?.customer?.locations?.length > 1 ? <Button className="edit-btn"
                              variant="outlined"
                              onClick={() => {

                                setSelectedData(val)
                                setShowDeleteConfirmationModal(true);

                              }}
                            >
                              Delete
                            </Button> : null}
                          </div>
                        </div>
                        <p className="align-items-center">
                          {val?.unitNo}
                        </p>
                        <p>
                          {val?.address}
                        </p>
                        <p>
                          Singapore {val?.postalCode}
                        </p>
                        <h6>{val?.generalLocation}</h6>
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                    <div className="acc-inf-d">
                      <p>Other Address(es)</p>
                      <h4>Granpa House 33 Clean Road Ave 4 Singapore 821330</h4>
                      <h6>Punggol</h6>
                    </div>
                  </div> */}
                  </div>
                </>

              ))}

            </div>
            <div className="acc-information adress-sec">
              <div className="d-flex justify-content-between align-items-baseline">
                <div className="profile-acc-inf">Preferred Staff </div>
                <Button
                  className="edit-btn"
                  variant="outlined"

                  onClick={() => editPrefferdStaffhandler()}
                >
                  Edit
                </Button>
              </div>

              <div className="prestaf">
                <h4>
                  Preferred staff is only available for our regular cleaning
                  services.
                </h4>
              </div>
              <div className="prestaf-main">
                <h6>Staff available for you:</h6>


              </div>
              <div className="profile-flex d-flex justify-content-start align-items-center">
                {myprofile?.preferredStaffs?.length > 0 ? myprofile?.preferredStaffs?.map((val) => {
                  return (
                    <>
                      <div className="profile-flex-box">
                        <div className="profile-box"><img src={val?.profileimageurl ? val?.profileimageurl : "/assets/images/staffAvatar.png"} /></div>
                        <p>{val.name}</p>
                       
                      {val?.isActive === "inactive" && <Badge
                      >
                        Inactive
                      </Badge>}
                      </div>

                    </>
                  )
                })
                  : "No staff available"
                }
              </div>
            </div>

            <div className="acc-information adress-sec">
              <div className="profile-acc-inf">Notifications </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="terms-conditions"
                  name="terms"
                  checked={myprofile?.isNotify}
                  onChange={(e) => updateNotificationFlag(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="terms-conditions">
                  Receive marketing and promotional updates via Email
                </label>
              </div>
            </div>

            {/* <div className="acc-information social-link">
          <div className="profile-acc-inf">Login via Social Accounts</div>
          <div className="prestaf">
            <h4> Connect with your social accounts for simple and secure sign-in. </h4>
          </div>
       <div className="d-flex justify-content-between align-items-center link-link">
        <div className="link-link-left"> <FontAwesomeIcon icon={faFacebookF} /> facebook </div>

       </div>
       <div className="d-flex justify-content-between align-items-center link-link">
       
        <div className="link-link-right">   <FontAwesomeIcon icon={faGoogle} /> Google </div>
       </div>
        </div> */}
          </div>
        </div>
      </div>
      {open && <EditModal isOpen={open} setIsOpen={setOpen} title={"Preferred Staff"} myprofile={myprofile}>

      </EditModal>}
      {showAccountModal && <EditModalAccount isOpen={showAccountModal} setIsOpen={setShowAccountModal} title={"Account Information"} myprofile={myprofile}>

      </EditModalAccount>}

      {showAddressModal && <AddEditAddressModal isOpen={showAddressModal} setIsOpen={setShowAddressModal} title={"Address(es)"} myprofile={selectedData} setSelectedData={setSelectedData} postalData={postalData} />}
      {showDeleteConfirmationModal && <CancelConfirmModel showDeleteConfirmationModal={showDeleteConfirmationModal} setShowDeleteConfirmationModal={setShowDeleteConfirmationModal} message={"Are you sure to delete your address?"} confirmDelete={confirmDelete} cancelDelete={cancelDelete} />}
      {changePassword &&
        <ChangePasswordModal
          open={changePassword}
          setOpen={setChangePassword}
        />
      }
    </>
  );
};

export default MyProfile;
